module.exports = __webpack_public_path__ + "static/pinkfairy6-45beac70a8d579743ddd8a8699436e79.png";